/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Browser } from './';
import {
    BrowserFromJSON,
    BrowserFromJSONTyped,
    BrowserToJSON,
} from './';

/**
 * 
 * @export
 * @interface MaltUserAgent
 */
export interface MaltUserAgent {
    /**
     * 
     * @type {string}
     * @memberof MaltUserAgent
     */
    category?: string;
    /**
     * 
     * @type {Browser}
     * @memberof MaltUserAgent
     */
    browser?: Browser;
}

/**
 * Check if a given object implements the MaltUserAgent interface.
 */
export function instanceOfMaltUserAgent(value: object): value is MaltUserAgent {
    return true;
}

export function MaltUserAgentFromJSON(json: any): MaltUserAgent {
    return MaltUserAgentFromJSONTyped(json, false);
}

export function MaltUserAgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaltUserAgent {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'browser': json['browser'] == null ? undefined : BrowserFromJSON(json['browser']),
    };
}

export function MaltUserAgentToJSON(value?: MaltUserAgent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': value['category'],
        'browser': BrowserToJSON(value['browser']),
    };
}

